import React, { useState, Fragment } from 'react';

import { LandingContents1 } from '../../styles/LandingStyles';
import InnerContainer from './InnerContainer';
import Typography from '../common/typography/Typography';
import styled from 'styled-components';
import useLanguagePack from '../../hooks/useLanguagePack';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../common/display/Modal';
import { TitleWrap } from '../../styles/UserStyles';
const Section3 = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const languageKeyStrings = {
    text: useLanguagePack('landing_contents1_text_1'),
    newText: useLanguagePack('renew_landing_13'),
    newText2: useLanguagePack('renew_landing_14'), //아티스트 등록절차
    newText3: useLanguagePack('renew_landing_15'), //제작
    newText4: useLanguagePack('renew_landing_16'), //회원가입
    newText5: useLanguagePack('renew_landing_18'), //포트폴리오 심사
    newText6: useLanguagePack('renew_landing_20'), //작가 승인
    newText7: useLanguagePack('renew_landing_22'), //업로드
    newText8: useLanguagePack('renew_landing_23'), //수익창출

    newText9: useLanguagePack('renew_landing_17'), //가입하기
    newText10: useLanguagePack('renew_landing_19'), //포트폴리오 가이드
    newText11: useLanguagePack('renew_landing_21'), //승인절차
  };
  return (
    <LandingContents1>
      <InnerContainer>
        <img src='/assets/image/newLanding/keycut_artist.png' alt='KEYCUTstock x Artist' style={{ marginBottom: '32px' }} />
        {/* <Typography variant={'L1'}>{languageKeyStrings.text}</Typography> */}
        <Typography variant={'C3'}>{languageKeyStrings.newText}</Typography>
        <Typography variant={'L1'} style={{ marginTop: '50px' }}>
          {languageKeyStrings.newText2}
        </Typography>
        <p style={{ width: '100px', height: '2px', background: '#1F7EFF' }}></p>
        <Box sx={{ display: 'flex', margin: '2rem' }}>
          <div
            style={{
              width: '128px',
              height: '128px',
              border: '1px solid white',
              borderRadius: '64px',
              display: 'flex',
              justifyContent: 'center',
              placeItems: 'center',
            }}
          >
            <Typography variant={'L1'}>{languageKeyStrings.newText3}</Typography>
          </div>
          <p style={{ background: 'white', display: 'flex', width: '55px', height: '1px', alignSelf: 'center', marginBottom: '65px' }}></p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div
              style={{
                width: '128px',
                height: '128px',
                border: '1px solid white',
                borderRadius: '64px',
                display: 'flex',
                justifyContent: 'center',
                placeItems: 'center',
                background: 'white',
                color: 'black',
              }}
            >
              <Typography variant={'L1'} color={'black'}>
                {languageKeyStrings.newText4}
              </Typography>
            </div>
            <div style={{ borderRadius: '20px', background: 'gray', height: '40px', display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant={'C3'}
                style={{ alignSelf: 'center', cursor: 'pointer' }}
                onClick={e => {
                  window.location.href = '/signup';
                }}
              >
                {languageKeyStrings.newText9}
              </Typography>
            </div>
          </div>
          <p style={{ background: 'white', display: 'flex', width: '55px', height: '1px', alignSelf: 'center', marginBottom: '65px' }}></p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', position: 'relative' }}>
            <div
              style={{
                width: '128px',
                height: '128px',
                border: '1px solid white',
                borderRadius: '64px',
                display: 'flex',
                justifyContent: 'center',
                placeItems: 'center',
                background: 'white',
                color: 'black',
              }}
            >
              <Typography variant={'L1'} color={'black'}>
                {languageKeyStrings.newText5}
              </Typography>
            </div>
            <div style={{ borderRadius: '20px', background: 'gray', height: '40px', display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant={'C3'}
                style={{ alignSelf: 'center', cursor: 'pointer' }}
                onClick={e => {
                  navigate('/guide');
                }}
              >
                {languageKeyStrings.newText10}
              </Typography>
            </div>
          </div>
          <p style={{ background: 'white', display: 'flex', width: '55px', height: '1px', alignSelf: 'center', marginBottom: '65px' }}></p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div
              style={{
                width: '128px',
                height: '128px',
                border: '1px solid white',
                borderRadius: '64px',
                display: 'flex',
                justifyContent: 'center',
                placeItems: 'center',
                background: 'white',
                color: 'black',
              }}
            >
              <Typography variant={'L1'} color={'black'}>
                {languageKeyStrings.newText6}
              </Typography>
            </div>
          </div>
          <p style={{ background: 'white', display: 'flex', width: '55px', height: '1px', alignSelf: 'center', marginBottom: '65px' }}></p>
          <div
            style={{
              width: '128px',
              height: '128px',
              border: '1px solid white',
              borderRadius: '64px',
              display: 'flex',
              justifyContent: 'center',
              placeItems: 'center',
            }}
          >
            <Typography variant={'L1'} style={{ alignSelf: 'center' }}>
              {languageKeyStrings.newText7}
            </Typography>
          </div>
          <p style={{ background: 'white', display: 'flex', width: '55px', height: '1px', alignSelf: 'center', marginBottom: '65px' }}></p>
          <div
            style={{
              width: '128px',
              height: '128px',
              border: '1px solid white',
              borderRadius: '64px',
              display: 'flex',
              justifyContent: 'center',
              placeItems: 'center',
            }}
          >
            <Typography variant={'L1'} style={{ alignSelf: 'center' }}>
              {languageKeyStrings.newText8}
            </Typography>
          </div>
        </Box>
      </InnerContainer>
      <Modal open={modalOpen} onClose={e => setModalOpen(false)} size={'lg'} children={<UploadGuide />} style={{ background: '#292929' }} />
    </LandingContents1>
  );
};

const UploadGuide = () => {
  const guideTitle1 = useLanguagePack('uploadpp61_title_4');
  const guideTitle2 = useLanguagePack('uploadpp61_title_5');
  const guideText1 = useLanguagePack('uploadpp61_text_3');
  const guideText2 = useLanguagePack('uploadpp61_text_4');
  const guideText3 = useLanguagePack('uploadpp61_text_5');
  const guideText4 = useLanguagePack('uploadpp61_text_6');
  const guideText5 = useLanguagePack('uploadpp61_text_7');
  const guideText6 = useLanguagePack('uploadpp61_text_8');
  const guideText7 = useLanguagePack('uploadpp61_text_9');
  const guideText8 = useLanguagePack('uploadpp61_text_10');
  const guideText11 = useLanguagePack('uploadpp61_text_11');
  const guideText12 = useLanguagePack('uploadpp61_text_12');
  const guideText13 = useLanguagePack('uploadpp61_text_13');
  const guideText14 = useLanguagePack('uploadpp61_text_14');
  const guideText15 = useLanguagePack('uploadpp61_text_15');
  const guideText16 = useLanguagePack('uploadpp61_text_16');
  const guideText17 = useLanguagePack('uploadpp61_text_17');
  const guideText18 = useLanguagePack('uploadpp61_text_18');
  const guideText19 = useLanguagePack('uploadpp61_text_19');
  const guideText20 = useLanguagePack('uploadpp61_text_20');
  const guideText21 = useLanguagePack('uploadpp61_text_21');
  const guideText22 = useLanguagePack('uploadpp61_text_22');
  const guideText23 = useLanguagePack('uploadpp61_text_23');
  const guideText24 = useLanguagePack('uploadpp61_text_24');
  const guideText25 = useLanguagePack('uploadpp61_text_25');
  const guideText26 = useLanguagePack('uploadpp61_text_26');
  const guideText27 = useLanguagePack('uploadpp61_text_27');
  const guideText28 = useLanguagePack('uploadpp61_text_28');
  const guideText29 = useLanguagePack('uploadpp61_text_29');
  const guideText30 = useLanguagePack('uploadpp61_text_30');
  const guideText31 = useLanguagePack('uploadpp61_text_31');
  const guideText32 = useLanguagePack('uploadpp61_text_32');
  const guideText33 = useLanguagePack('uploadpp61_text_33');
  const guideText34 = useLanguagePack('uploadpp61_text_34');
  const guideText35 = useLanguagePack('uploadpp61_text_35');
  const guideText36 = useLanguagePack('uploadpp61_text_36');
  const guideText37 = useLanguagePack('uploadpp61_text_37');
  const guideText38 = useLanguagePack('uploadpp61_text_38');
  const guideText39 = useLanguagePack('uploadpp61_text_39');
  const guideText40 = useLanguagePack('uploadpp61_text_40');
  const guideText41 = useLanguagePack('uploadpp61_text_41');
  const guideText42 = useLanguagePack('uploadpp61_text_42');
  const guideText43 = useLanguagePack('judge_sentence_4');
  const guideText44 = useLanguagePack('judge_sentence_5');
  const guideText45 = useLanguagePack('judge_sentence_6');
  const guideText46 = useLanguagePack('judge_sentence_7');
  const guideText47 = useLanguagePack('renew_landing_47');

  return (
    <Fragment>
      <div>
        <TitleWrap>
          <Typography variant={'L1'}>{guideText47}</Typography>
        </TitleWrap>
      </div>
      <div>
        <TableStyled>
          <div className='tr'>
            <div className='td'>
              <span>{guideText2}</span>
            </div>
            <div className='td'>
              <span>{guideText3}</span>
            </div>
            <div className='td'>
              <span>{guideText4}</span>
            </div>
            <div className='td'>
              <span>{guideText5}</span>
            </div>
            <div className='td'>
              <span>{guideText6}</span>
            </div>
          </div>
          <div className='tr'>
            <div className='td'>
              <span>{guideText7}</span>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText11}</li>
                <li>{guideText12}</li>
                <li>{guideText13}</li>
                <li>{guideText14}</li>
                <li>{guideText15}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText16}</li>
                <li>{guideText17}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText18}</li>
                <li>{guideText19}</li>
                <li>{guideText20}</li>
                <li>{guideText21}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText22}</li>
                <li>{guideText23}</li>
                <li>{guideText24}</li>
                <li>{guideText25}</li>
                <li>{guideText26}</li>
                <li>{guideText43}</li>
              </ul>
            </div>
          </div>
          <div className='tr'>
            <div className='td'>
              <span>{guideText8}</span>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText27}</li>
                <li>{guideText28}</li>
                <li>{guideText29}</li>
                <li>{guideText30}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText31}</li>
                <li>{guideText32}</li>
                <li>{guideText33}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText34}</li>
                <li>{guideText35}</li>
                <li>{guideText36}</li>
              </ul>
            </div>
            <div className='td'>
              <ul>
                <li>{guideText37}</li>
                <li>{guideText38}</li>
                <li>{guideText39}</li>
                <li>{guideText40}</li>
                <li>{guideText41}</li>
                <li>{guideText44}</li>
              </ul>
            </div>
          </div>
        </TableStyled>
      </div>
    </Fragment>
  );
};

const TableStyled = styled.div`
  border: 1px solid rgba(102, 102, 102, 1);
  border-bottom: none;
  border-right: none;
  width: 100%;

  .tr {
    display: flex;
    border-bottom: 1px solid rgba(102, 102, 102, 1);

    &:first-of-type {
      .td {
        background: #323232;
        &:first-of-type {
          color: #888888;
        }
      }
    }
  }

  .td {
    width: 25%;
    padding: 12px 10px;
    border-right: 1px solid rgba(102, 102, 102, 1);

    &:first-of-type {
      width: 10%;
      background: #222;
    }

    span {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ul {
      padding-left: 16px;
      margin: 0;

      li {
        font-weight: 500;
        font-size: 14px;
        color: #dddddd;
        margin-bottom: 7px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
`;

export default Section3;
